module.exports = __webpack_public_path__ + "static/hill3-a2e7f843903a0bb24ea74c11c926be1e.svg";